import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=a985415a&scoped=true"
import script from "./BookingCard.vue?vue&type=script&lang=js"
export * from "./BookingCard.vue?vue&type=script&lang=js"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=a985415a&prod&lang=css"
import style1 from "./BookingCard.vue?vue&type=style&index=1&id=a985415a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a985415a",
  null
  
)

export default component.exports